import React from 'react';
import { MessageCircle } from 'lucide-react';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  const openWhatsApp = () => {
    const text = 'Hello RV Clinic, I would like to inquire about your services.';
    const whatsappUrl = `https://web.whatsapp.com/send?phone=917048944596&text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="whatsapp-float" onClick={openWhatsApp}>
      <div className="whatsapp-label">Chat with us</div>
      <div className="whatsapp-btn">
        <MessageCircle size={28} fill="white" />
      </div>
    </div>
  );
};

export default WhatsAppFloat;
